export enum DateRangeTypeEnum {
    Dynamic = 0,
    Fixed = 1,
}
